import { MouseEvent } from "react";

import { css } from "@compiled/react";

import { N0, N20, N500 } from "@atlaskit/theme/colors";

import { GoogleLogo, MicrosoftLogo, AppleLogo, SlackLogo } from "./logos";

type LogoType = "google" | "microsoft" | "apple" | "slack";

const ProviderLogo = ({ logo }: { logo: LogoType }) => {
    switch (logo) {
        case "google":
            return <GoogleLogo />;
        case "microsoft":
            return <MicrosoftLogo />;
        case "apple":
            return <AppleLogo />;
        case "slack":
            return <SlackLogo />;
    }
};

export const LogoButton = ({
    hasRebrandedSignupFormStyles,
    href,
    onClick,
    type,
    label
}: {
    readonly hasRebrandedSignupFormStyles?: boolean;
    readonly href: string;
    readonly onClick: (e: MouseEvent) => void;
    readonly type: LogoType;
    readonly label: React.ReactNode;
}) => (
    <a
        css={[
            logoButtonCss,
            hasRebrandedSignupFormStyles && roundedLogoButtonCss
        ]}
        href={href}
        onClick={onClick}
        id={`${type}-social-button`}
        aria-label={type}
    >
        <ProviderLogo logo={type} /> {label}
    </a>
);

const roundedLogoButtonCss = css({
    borderRadius: "40px"
});

const logoButtonCss = css({
    "alignItems": "center",
    "backgroundColor": N0,
    "borderRadius": 3,
    "boxShadow": "0px 1px 1px 0px #091E4240, 0px 0px 1px 0px #091E424F",
    "color": `${N500} !important`,
    "display": "flex",
    "gap": "0.5rem",
    "height": "40px",
    "justifyContent": "center",
    "padding": "0.5rem 0.75rem",
    "textDecoration": "none !important",

    "&:focus, &:hover": {
        backgroundColor: N20,
        color: `${N500} !important`
    },

    "&:focus-visible": {
        "outline-offset": 1
    }
});
